module.exports.boothDeepAndShalow = (strIn) -> return "DEEP_TEST" + strIn